import { useCallback } from "react";
import { DatePicker } from "components/inputs";
import type { DocumentType } from "../../DocumentTypes";
import type { DocumentTableDataType } from "../../DocumentTableTypes";

type Props = {
  row: DocumentTableDataType;
  onChange: (doc: DocumentType, date: Date | null) => void;
  onLocalUpdate: (rowId: number, date: Date | null) => void;
  datePickerRefs: React.MutableRefObject<
    Map<number, { setOpen?: (open: boolean) => void } | null>
  >;
};

export const DatePickerCell = ({
  row,
  onChange,
  onLocalUpdate,
  datePickerRefs,
}: Props) => {
  const handleDatePickerFocus = useCallback(() => {
    // close all other datepickers
    datePickerRefs.current.forEach((ref, rowId) => {
      if (rowId !== row.id && ref && typeof ref.setOpen === "function") {
        ref.setOpen(false);
      }
    });
  }, [row.id, datePickerRefs]);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        handleDatePickerFocus();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <DatePicker
        name={`document-date-${row.id}`}
        className="rdg-date-editor"
        label=""
        initialDate={
          row.document.document_date
            ? new Date(row.document.document_date)
            : undefined
        }
        ref={(pickerRef) => {
          if (pickerRef) {
            datePickerRefs.current.set(row.id, pickerRef);
          } else {
            datePickerRefs.current.delete(row.id);
          }
        }}
        onDateChange={(date: Date | null) => {
          onChange(row.document, date);
          onLocalUpdate(row.id, date);
        }}
      />
    </div>
  );
};
